import React, { PureComponent } from "react";
import Request from "../../networkReq/request";
import { Link } from "react-router-dom";
import PagingContent from 'components/PagingContent'
require("./preferentialInfo.css");

export default class PreferntialInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      infoList: [],
      params: {
        size: 10,
        type: 1,
      },
    }

  }




  renderList(data) {
    if (data == '' || !data.records) {
      return '';
    }
    let records = data.records;
    return (
      <ul>
        {records && records.length > 0 ? records.map((item, index) => {
          return (
            <li key={index}>
              <Link to={"/preferential/preferentialInformationDetail?" + item.id}>
                <div className="cont_list_dot"></div>
                <div className="cont_list_txt">{item.title}</div>
                <div className="cont_list_time">{item.createTime.slice(0, 10)}</div>
              </Link>
            </li>
          )
        }) : null
        }
      </ul>
    )
  }

  render() {
    return (
      <div>
        {/* 内容 */}
        <div className="content" style={{ marginTop: '0' }}>
          <div className="container clear">
            <div className="content_list" style={{ width: '100%' }}>
              <PagingContent requestUrl={Request.getArticlelist()} renderList={this.renderList} params={this.state.params} />
            </div>
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
